import React from 'react';
import './MySquare.css';

function MySquare({ color, symbol, onClick }) {
    return (
        <div 
            className="my-square" 
            style={{ backgroundColor: color }} 
            onClick={onClick}
        >
            <span className="my-square-symbol">{symbol}</span>
        </div>
    );
}

export default MySquare;